/** The settings version this session loaded: the `$options` stamp and the `$rates` `_rev`. */
export interface LoadedSettingsVersion {
  options?: number
  ratesRev?: string
}

/** What the `settingsVersion` query returned. `null` means the server has no value to compare. */
export interface CurrentSettingsVersion {
  options: number | null
  ratesRev: string | null
}

/**
 * Whether another session changed the settings this session loaded (#25436).
 *
 * The comparison is `!==`, not `>`: a CouchDB conflict re-saves the incoming doc, so a background
 * write can put back an older stamp. Any difference means this copy is not the server's copy.
 *
 * A `null` current value never counts, so a legacy doc with no stamp, or a failed rates read, cannot
 * raise the notice. A missing loaded stamp against a current one does count: the doc was stamped
 * after this session loaded it.
 */
export function isSettingsOutdated(
  loaded: LoadedSettingsVersion,
  current: CurrentSettingsVersion | null | undefined
): boolean {
  if (!current) {
    return false
  }

  const optionsChanged = current.options != null && current.options !== loaded.options
  const ratesChanged = current.ratesRev != null && current.ratesRev !== loaded.ratesRev

  return optionsChanged || ratesChanged
}
